import axios, { AxiosRequestHeaders } from "axios";
import { FormEventHandler, useCallback, useEffect, useState } from "react";
import { ILoginData2 } from "../../../models";
import { HOSTNAME } from "../api-utils";
import { ApiTesterComponent, IApiFetcher } from "../ApiTesterApp";
import { usersFavoritesGetGet } from "./UsersFavoritesGet";

export const usersFavoritesAddPost: IApiFetcher = async ({
  utoken,
  data,
  omitUserAgent = false,
}: {
  utoken: string;
  data: any;
  omitUserAgent?: boolean;
}) => {
  const headers: AxiosRequestHeaders = {};
  if (!omitUserAgent) {
    headers["User-Agent"] = "I:2.5.0(256)";
  }
  headers["utoken"] = utoken;

  const parsedData = JSON.parse(data);

  const response = await axios.post<any>(
    `${HOSTNAME}${usersFavoritesAddPost.url}`,
    { items: [parsedData] },
    {
      headers,
    }
  );
  return response.data;
};
usersFavoritesAddPost.url = "/wp-json/wp/v3/users/favorites/add";
usersFavoritesAddPost.method = 'POST';

const UsersFavoritesAdd: ApiTesterComponent = ({ loginData }: { loginData: ILoginData2 | null }) => {
  const [toAdd, setToAdd] = useState<string>("");
  const [data, setData] = useState<string>("");
  const [loading, setIsLoading] = useState<boolean>(true);

  const libraryGetBinded = useCallback(() => loginData ? usersFavoritesGetGet({utoken: loginData.token, omitUserAgent: true}).then(data => {
    setData(JSON.stringify(data, null, 2));
    setIsLoading(false);
  }) : undefined, [loginData]);

  useEffect(() => {
    libraryGetBinded();
  }, [libraryGetBinded])

  const onAddToPlaylist: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();

    if (loginData?.token) {
      setIsLoading(true);
       UsersFavoritesAdd.fetcher({
        utoken: loginData.token,
        data: toAdd,
        omitUserAgent: true,
      }).then(() => {
        libraryGetBinded();
      });
    }
  };

  return (
    <div>
      <h3>UsersFavoritesAdd</h3>
      <form onSubmit={onAddToPlaylist}>
        <input
          type="text"
          value={toAdd}
          required
          onChange={(event) => setToAdd(event.target.value)}
        />
        <input type="submit" value="Add" />
      </form>
      <pre>{loading ? "Loading..." : data}</pre>
    </div>
  );
};

UsersFavoritesAdd.fetcher = usersFavoritesAddPost;

export default UsersFavoritesAdd;
